import gql from 'graphql-tag';

const CREATE_FRICTIONLESS_TAG = gql`
  mutation createFrictionlessTag($data: CreateFrictionlessTagInput!) {
    createFrictionlessTag(data: $data) {
      success
      message
      tag {
        name
        path
      }
    }
  }
`;

export default CREATE_FRICTIONLESS_TAG;
